import { render, staticRenderFns } from "./relevance.vue?vue&type=template&id=c55a6b64&scoped=true&"
import script from "./relevance.vue?vue&type=script&lang=js&"
export * from "./relevance.vue?vue&type=script&lang=js&"
import style0 from "./relevance.vue?vue&type=style&index=0&id=c55a6b64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55a6b64",
  null
  
)

export default component.exports